module.exports = __webpack_public_path__ + "img/20200619_160518.f97d7f7c.jpg";